<template>
  <div class="col-12 activityOutcomeAndManualScoringContainer">
    <div class="row">
      <div class="col-md-8">
        <h3>Knowledge Check Review - {{data.name}}</h3>
      </div>
      <div class="col-md-4">
        <h3>Teacher Scoring</h3>
      </div>
    </div>
    <span class="learnosity-report" id="sessionDetailByItemReport"></span>
    <div class="row">
      <div class="col-md-8"></div>
      <div class="col-md-4 btn_container">
        <span class="learnosity-save-button"></span>
      </div>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  /* global LearnosityItems LearnosityReports:true */
  import '../../../assets/module/css/assessment/manualGrading.min.css'
  import { mapActions } from 'vuex'

  export default {
    name: 'manual-grading',
    props: ['data'],
    data () {
      return {
        reportsApp: {},
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        rubricPdfUri: '',
        rubricViewerUrl: 'https://drive.google.com/viewerng/viewer?url='
      }
    },
    beforeMount () {
      this.rubricPdfUri = this.data.manualGradingRubricPdfUri
      if (this.rubricPdfUri && this.rubricPdfUri.length > 0) {
        this.rubricViewerUrl += this.rubricPdfUri + '&embedded=true'
      }
    },
    mounted () {
      this.loadClassAttemptManualGradingReportForUser()
    },
    methods: {
      ...mapActions([
        'showClassAttemptManualGradingReportForUser',
        'updateAttemptManualGradeForUser',
        'launchManualGradingForUser'
      ]),
      loadClassAttemptManualGradingReportForUser () {
        this.showClassAttemptManualGradingReportForUser({activityId: this.data.activityId, userId: this.data.userId, sessionId: this.data.sessionId}).then(data => {
          if (data) {
            this.initializeLearnosityReports(data)
          }
        })
      },
      initializeLearnosityReports (data) {
        var self = this
        self.reportsApp = LearnosityReports.init(data, {
          'readyListener': function () {
            self.bindReportReadyListener()
          },
          'errorListener': function (event) {
            console.log('error: ', event)
          }
        })
      },
      bindReportReadyListener () {
        var itemReferences = []
        var report = this.reportsApp.getReport('sessionDetailByItemReport')
        report.on('ready:itemsApi', (itemsApp) => {
          itemsApp.getQuestions((questions) => {
            $.each(questions, (index, question) => {
              if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                var reference = question.metadata.rubric_reference
                var itemId = question.response_id + '_' + reference

                $('<span class="learnosity-item" data-reference="' + itemId + '">')
                  .appendTo($('#' + question.response_id).closest('.row'))
                  .wrap('<div class="teacher_scoring" id=' + itemId + '></div>')

                if (this.rubricPdfUri && this.rubricPdfUri.length > 0) {
                  let viewRubricButtonId = itemId + '_rubricViewer'
                  let viewRubric = $('<div class="pull-right"><button type="button" class="btn btn-default" id=' + viewRubricButtonId + '>View Rubric</button></div>')
                  $('#' + itemId).append(viewRubric)

                  $('#' + viewRubricButtonId).click(() => {
                    this.showRubricViewerModal()
                  })
                }

                itemReferences.push({'id': itemId, 'reference': reference})
                this.scoringObjects[itemId] = question
              }
            })
          })

          if (itemReferences.length > 0) {
            var itemsActivity = {
              'type': 'feedback',
              'state': 'initial',
              'rendering_type': 'inline',
              'user_id': this.data.userId,
              'session_id': this.data.sessionId,
              'activity_id': this.data.activityId,
              'items': itemReferences,
              'config': {
                'renderSaveButton': true,
                'labelBundle': {
                  'saveButtonLabel': 'save',
                  'saveInProgress': 'save',
                  'saveComplete': 'save'
                }
              }
            }

            this.launchManualGradingForUser(itemsActivity).then(res => {
              if (res) {
                var self = this
                self.itemsAppTeacherScoring = LearnosityItems.init(res, {
                  readyListener: function () {
                    self.generateScoreStimulus()
                    $('.lrn_save_button').click(() => {
                      self.$refs.loadingModal.show()
                      self.onClickingSave()
                    })
                  }
                })
              }
            })
          }
        })
      },
      onClickingSave () {
        this.itemsAppTeacherScoring.save({
          success: () => {
            this.saveScores()
          },
          error: () => {
            setTimeout(() => {
              this.$refs.loadingModal.hide()
              this.$notify({
                group: 'notify',
                type: 'error',
                title: 'Error Message',
                text: 'Unable to update the score due to <strong>feedback validation failed.</strong>'
              })
            }, 2500)
          }
        })
      },
      generateScoreStimulus () {
        $.each(this.itemsAppTeacherScoring.getItems(), (index, item) => {
          const question = this.scoringObjects[index]
          const text = 'Enter score between 0-' + ((question.validation && question.validation.max_score) ? question.validation.max_score : 1)
          const elemId = 'stimulus-' + item.response_ids[0]
          $('#' + elemId).text(text)
        })
      },
      saveScores () {
        let responses = []
        let teacherItems = this.itemsAppTeacherScoring.getItems()
        let teachersResponses = this.itemsAppTeacherScoring.getResponses()
        $.each(this.itemsAppTeacherScoring.attemptedItems(), (index, itemId) => {
          let score = 0
          let maxScore = 1
          let responseObject = this.scoringObjects[itemId]
          if (responseObject.validation && responseObject.validation.max_score) {
            maxScore = responseObject.validation.max_score
          }
          var responseId = teacherItems[itemId].response_ids[0]
          var response = teachersResponses[responseId]
          if (response && response.value) {
            const value = Number(response.value)
            if (!isNaN(value)) {
              score = value
            }
          }
          responses.push({
            'score': score,
            'max_score': maxScore,
            'attempted': true,
            'response_id': responseObject.response_id
          })
        })

        if (responses.length > 0) {
          var isValid = true
          for (var i = 0; i < responses.length; i++) {
            var response = responses[i]
            if (response.score < 0) {
              isValid = false
              break
            }
          }
          if (isValid) {
            var data = {
              'responses': responses,
              'user_id': this.data.userId,
              'session_id': this.data.sessionId,
              'activity_id': this.data.activityId
            }
            this.updateAttemptManualGradeForUser(data).then(res => {
              this.$refs.loadingModal.hide()
              if (res) {
                if (res.meta.status) {
                  this.$emit('saveScore')
                } else {
                  this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Error Message',
                    text: 'Unable to update the score due to <strong>' + res.meta.message + '</strong>'
                  })
                }
              }
            })
          } else {
            setTimeout(() => {
              this.$refs.loadingModal.hide()
              this.$notify({
                group: 'notify',
                type: 'error',
                title: 'Error Message',
                text: 'Unable to update the score due to <strong>score cannot be less than min_score</strong>'
              })
            }, 5000)
          }
        }
      },
      showRubricViewerModal () {
        let childWindow = window.open(this.rubricPdfUri, '_blank', 'height=650,width=1200,status=yes,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,directories=no,left=150,top=50')
        childWindow.focus()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/assessment/components/ManualGrading.vue